<script lang="ts">
import {translate} from "$lib/i18n";
  interface Props {
    currentPage?: number;
    totalElements?: number;
    loading?: boolean;
    loadMore: () => void;
  }

  let {
    currentPage = 0,
    totalElements = 0,
    loading = false,
    loadMore
  }: Props = $props();

  let amountOfGames = $derived(Math.min(currentPage * 32, totalElements));
  let percentage = $derived(Math.min(Math.round(((currentPage * 32) / totalElements) * 100), 100));
  let isHovering = $state(false);
</script>

{#if !loading}
  <div class="flex flex-col justify-center items-center mt-10">
    <div class="text-[#CBD5E0] flex items-center bg-primary-darkNavy/30 px-4 py-2 rounded-xl shadow-md">
      <span class="text-white font-medium">
        {amountOfGames}
      </span>
      <span class="mx-1 text-primary-secondaryText">of {totalElements}</span>
      <div class="w-40 rounded-full bg-primary-darkNavy/50 mx-3 h-3 overflow-hidden shadow-inner">
        <div class="h-3 rounded-full bg-gradient-to-r from-primary-green to-primary-buttonHover transition-all duration-500 ease-out" 
             style="width: {percentage}%"></div>
      </div>
      <span class="text-white font-medium">{percentage}<span class="text-primary-secondaryText text-sm">%</span></span>
    </div>

    {#if amountOfGames < totalElements}
      <button 
        class="group flex items-center gap-2 bg-gradient-to-r from-primary-green to-primary-buttonHover hover:from-primary-buttonHover hover:to-primary-green text-white py-2.5 px-6 rounded-xl mt-6 transition-all duration-300 shadow-md hover:shadow-lg hover:shadow-primary-green/20 transform hover:-translate-y-0.5"
        on:click={loadMore}
        on:mouseenter={() => isHovering = true}
        on:mouseleave={() => isHovering = false}>
        <span class="font-medium">{$translate('Load More')}</span>
        <svg class="w-5 h-5 transition-transform duration-300 {isHovering ? 'translate-y-0.5' : ''}" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.82042 10.0198L9.03042 13.2298L10.9904 15.1998C11.8204 16.0298 13.1704 16.0298 14.0004 15.1998L19.1804 10.0198C19.8604 9.33977 19.3704 8.17977 18.4204 8.17977L12.8104 8.17977L6.58042 8.17977C5.62042 8.17976 5.14042 9.33977 5.82042 10.0198Z" fill="white" transform="rotate(180 12.5 12)"/>
        </svg>
      </button>
    {/if}
  </div>
{/if}
